import React, { useState } from 'react'
import TaskSearchModal from '../../pages/Settings/Modal/TaskSearchModal'
import { CmdKeyIcon, MagnifyingGlassIcon } from "./Feedback/icons/Icons"
import { getKeyboardSymbol, isMac } from '../action/utilities';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const TaskSearchInput = ({theme}) => {
    const [taskSearchModal, setTaskSearchModal] = useState(false);
    const navigate = useNavigate();
    const settings = useSelector(state => state.settings.settings)

    const hideModal = () => {
        setTaskSearchModal(false);
        navigate(process.env.REACT_APP_ROOT);
    }

    return (
        <>
            <div className="task-search-shortcut parts" onClick={e => setTaskSearchModal(true)}>
                <span className="darkPrimaryColor opacity-40 w-[76px]">Search</span>
                {
                    typeof settings.keyboardShortcuts == 'undefined' || settings?.keyboardShortcuts?.searchTask?.length > 0
                    ?
                    <span className="shortcut">{settings?.keyboardShortcuts?.searchTask?.length > 0 ? settings?.keyboardShortcuts?.searchTask.map(item => getKeyboardSymbol(item, true)).join(' ') : (isMac ? <><CmdKeyIcon /> K</> : ['Ctrl', 'K'].map(item => getKeyboardSymbol(item, true)).join(' '))}</span>
                    :
                    null
                }
                <MagnifyingGlassIcon customClass="opacity-30" />
            </div>
            {
                taskSearchModal && <TaskSearchModal onHide={hideModal} theme={theme} />
            }
        </>
    )
}

export default TaskSearchInput